/*
  Media helpers for product descriptions.

  1. Lazy autoplay videos.
     Markup: <video data-ymg-src="URL" poster="URL" muted loop playsinline preload="none"></video>
     The file only downloads once the video is within ~300px of the viewport.
     With reduced motion, the video gets controls instead of autoplaying.

  2. YouTube click-to-play.
     Markup: <a class="ymg-yt" data-ymg-yt="VIDEO_ID" href="https://www.youtube.com/watch?v=VIDEO_ID" title="Play video: ...">
               <img src="https://i.ytimg.com/vi/VIDEO_ID/hqdefault.jpg" loading="lazy" alt="..."><span class="ymg-yt-play" aria-hidden="true"></span>
             </a>
     YouTube only loads when the thumbnail is clicked. Without JS, the link opens the video on YouTube.
*/
document.addEventListener('click', function(e) {
  var link = e.target.closest && e.target.closest('a.ymg-yt[data-ymg-yt]');
  if (!link) return;
  e.preventDefault();
  var id = encodeURIComponent(link.getAttribute('data-ymg-yt'));
  var frame = document.createElement('iframe');
  frame.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
  frame.title = (link.getAttribute('title') || 'YouTube video').replace(/^Play video:\s*/, '');
  frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  frame.setAttribute('allowfullscreen', '');
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  var box = document.createElement('div');
  box.className = 'ymg-yt ymg-yt--playing';
  box.appendChild(frame);
  link.parentNode.replaceChild(box, link);
  frame.focus();
});

(function() {
  var videos = document.querySelectorAll('video[data-ymg-src]');
  if (!videos.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(v) {
    if (v.getAttribute('src')) return;
    v.muted = true;
    v.setAttribute('src', v.getAttribute('data-ymg-src'));
    if (reduce) {
      v.controls = true;
      v.preload = 'metadata';
      v.load();
      return;
    }
    v.load();
    var p = v.play();
    // If autoplay is blocked (e.g. low-power mode), fall back to tap-to-play
    if (p && p.catch) p.catch(function() { v.controls = true; });
  }

  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < videos.length; i++) start(videos[i]);
    return;
  }

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { start(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '300px 0px' });

  for (var j = 0; j < videos.length; j++) io.observe(videos[j]);
})();
